keygetStandardTexts<template>
	<Editor v-if="!propInit" :id="'editor_' + _uid" :init="init" v-model="htmlLocal" :key="refreshToken"/>
	<Editor v-else :id="'editor_' + _uid" :init="propInit" v-model="htmlLocal"/>
</template>
<script>
import Quill from 'quill';
import Editor from "@tinymce/tinymce-vue";
const Delta = Quill.import('delta');

export default{
	props:['propInit', 'html', 'id'],
	model: {
		prop: 'html',
		event: 'htmlchange'
	},
	computed: {
		htmlLocal: {
			get: function() {
				if (this.html !== undefined) {
					return this.html;
				}

				return null;
			},
			set: function(value) {
				if  (value !== undefined) {
					this.$emit('htmlchange', value)
				}
			}
		},
	},
	data() {
		return{
			init: {
				license_key: 'gpl',
				height: 375,
				plugins: 'image code link table lists advlist', // emoticons - can not be saved in database yet
				toolbar: 'undo redo | pastetext | styleselect | bold italic underline | fontselect | fontsizeselect | alignleft aligncenter alignright alignjustify | outdent indent | forecolor hilitecolor',
				//toolbar: "sizeselect | bold italic |",
				toc_depth: 6,
				paste_data_images: true, //known issue to break editor after loading in the dragged image
				image_advtab:true,
				image_class_list: [
					{title: this.$t('fullWidth.label'), value: 'full-width'},
					{title: this.$t('three_quarters_width.label'), value: 'three-quarters-width'},
					{title: this.$t('halve_width.label'), value: 'halve-width'},
					{title: this.$t('quarter_width.label'), value: 'quarter-width'},
					// {title: this.$t('default.label'), value: ''},
				],
				toolbar_mode: 'sliding',
				image_uploadtab: true,
				images_upload_handler: function (blobInfo, success, failure) {
					var xhr, file;
					xhr = new XMLHttpRequest();
					xhr.withCredentials = true;
					xhr.open('POST', process.env.VUE_APP_API_URL + '/wysiwyg/uploadImage');

					xhr.onload = function() {
						var json;

						if (xhr.status != 200) {
							failure('HTTP Error: ' + xhr.status);
							return;
						}
						if (xhr.responseText === undefined || xhr.responseText.length == 0) {
							failure('Image exceeds max filesize of 2MB');
							return;
						}
						
						json = JSON.parse(xhr.responseText);
						if (!json || typeof json.location != 'string') {
							failure('Invalid JSON: ' + xhr.responseText);
							return;
						}
						success(json.location);

					};
					let files = new FormData;
					file = new File([blobInfo.blob()], blobInfo.filename());
					if (file instanceof File){
						files.append('image', file);
						xhr.send(files);
					}
				}.bind(this)
			},
			standardTexts: [],
			refreshToken: 0,
		}
	},
	methods: {
		
		setTinyMCE: function() {
			let init = {
				license_key: 'gpl',
				height: 375,
				plugins: 'code link table lists advlist',
				toolbar: 'undo redo | styleselect | bold italic underline | fontselect | fontsizeselect | alignleft aligncenter alignright alignjustify | outdent indent | forecolor hilitecolor',
				toc_depth: 6,
				toolbar_mode: 'sliding'
			}
			this.$set(this, 'init', init);
			this.refreshToken++;
		}

	},
	created() {
		this.getStandardTexts();
	},
	components: {
		Editor,
	},
}
</script>